import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { ARRAY_ERROR } from 'final-form';
import { FormSpy } from 'react-final-form';
import { useCallback, useEffect, useState } from 'react';

import { IDictionaryEventTypeSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionaryEventTypeSelectOption';
import { EVENTS_BLOCK_ID } from 'KnmErknmPackage/MainModule/constants/knmErknmFieldsElementsIds';
import { IKnmErknmFormEvent } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormEvent';
import { Button } from 'UIPackage/MainModule/components/Button';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { DECISION_EVENTS } from 'CorePackage/MainModule/routes/routes';

import { IInteractionCategorySelectOption } from '../../../CorePackage/CatalogsModule/interfaces/IInteractionCategorySelectOption';
import { getDecisionFormRef } from '../../MainModule/selectors/decisionSelectors';
import { IDecisionFormRef } from '../../MainModule/interfaces/IDecisionFormRef';
import { DecisionEventItem } from './DecisionEventItem';
import { getCatalogsInteractionCategorySelectOptions } from '../../../CorePackage/CatalogsModule/selectors/catalogsSelectors';
import { DecisionFieldMark } from '../../MainModule/components/DecisionFieldMark';

interface IDecisionEventsProps {
  eventTypesSelectOptions: IDictionaryEventTypeSelectOption[] | undefined;
  isWatchOnly: boolean;
  decisionMinEventStartDateTime?: string;
}

interface IDecisionEventsStoreProps {
  formRef: IDecisionFormRef | undefined;
  interactionCategoryOptions: IInteractionCategorySelectOption[] | undefined;
}

const DecisionEventsWithoutStore = ({
  eventTypesSelectOptions,
  isWatchOnly,
  formRef,
  interactionCategoryOptions,
  decisionMinEventStartDateTime,
}: IDecisionEventsProps & IDecisionEventsStoreProps) => {
  const push = formRef?.current.mutators.push;
  const [uniqKnmEventTypesSelectOptions, setUniqKnmEventTypesSelectOptions] = useState<
    IDictionaryEventTypeSelectOption[] | undefined
  >(eventTypesSelectOptions);

  const addEvent = useCallback(() => {
    if (!isWatchOnly && push) {
      const addingEvent: IKnmErknmFormEvent = {
        guid: undefined,
        type: undefined,
        startDate: undefined,
        stopDate: undefined,
        dateCreate: undefined,
        interactionCategory: undefined,
        listId: uuidv4(),
        isNew: true,
        submittedDocuments: undefined,
      };

      push('events', addingEvent);
    }
  }, [formRef?.current.getFieldState('events'), push, isWatchOnly, eventTypesSelectOptions]);

  useEffect(() => {
    const eventTypes = formRef?.current.getFieldState('events')?.value?.map(x => x.type);

    if (!uniqKnmEventTypesSelectOptions) {
      if (eventTypes) {
        setUniqKnmEventTypesSelectOptions(
          eventTypesSelectOptions?.filter(x => !eventTypes.find(type => type?.title === x.title)),
        );
      } else {
        setUniqKnmEventTypesSelectOptions(eventTypesSelectOptions);
      }
    }
  }, [uniqKnmEventTypesSelectOptions, eventTypesSelectOptions, formRef?.current.getFieldState('events')]);

  return (
    <FieldBlock
      label={
        <>
          Перечень действий, осуществляемых в рамках КНМ, СР
          <DecisionFieldMark fieldName="events" />
        </>
      }
      id={DECISION_EVENTS}
      margin="bottom"
      button={
        <Button
          className="shared-btn-add"
          text="Добавить"
          variant="link"
          color="primary"
          type="button"
          id="decisionEventsAddButton"
          disabled={isWatchOnly}
          onClick={addEvent}
        />
      }
      labelId={EVENTS_BLOCK_ID}
    >
      <FormSpy subscription={{ errors: true, touched: true }}>
        {props => {
          const fieldError = props.errors?.events?.[ARRAY_ERROR];
          const isFieldTouched = props.touched?.events;

          if (isFieldTouched && fieldError) {
            return <p className="shared-input-error shared-row__small-margin">{fieldError}</p>;
          }

          return null;
        }}
      </FormSpy>
      <DecisionEventItem
        interactionCategoryOptions={interactionCategoryOptions}
        watchOnly={isWatchOnly}
        uniqKnmEventTypesSelectOptions={uniqKnmEventTypesSelectOptions}
        setUniqKnmEventTypesSelectOptions={setUniqKnmEventTypesSelectOptions}
        knmEventTypesSelectOptions={eventTypesSelectOptions}
        decisionMinEventStartDateTime={decisionMinEventStartDateTime}
      />
    </FieldBlock>
  );
};

const mapStateToProps = (state: IRootState): IDecisionEventsStoreProps => ({
  formRef: getDecisionFormRef(state),
  interactionCategoryOptions: getCatalogsInteractionCategorySelectOptions(state),
});

export const DecisionEvents = connect(mapStateToProps)(DecisionEventsWithoutStore);
